var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"filterable":"","clearable":true,"placeholder":"Select","disabled":_vm.disabled},model:{value:(_vm.useModel),callback:function ($$v) {_vm.useModel=$$v},expression:"useModel"}},_vm._l((_vm.options),function(approval){return _c('el-option',{key:approval.id,attrs:{"value":approval.id,"label":approval.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }